/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Drawer,
  MenuItem,
  Divider,
  Icon,
  Collapse,
  Card,
  CardHeader,
  CardContent,
  ListSubheader,
  CardActions,
  IconButton,
} from "@mui/material";
import {
  Person,
  Redeem,
  History,
  FavoriteBorder,
  LocalActivity,
  Home,
  Done,
  DoneAll,
  HelpOutline,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getUserType } from "utils/helpers";
import map from "lodash/map";
import get from "lodash/get";
import find from "lodash/find";
import { FormattedMessage, FormattedNumber } from "react-intl";

import messages from "./messages";

// TODO remove hardcoded
import DefaultAvatar from "./avatar.jpg";

const styles = {
  card: {
    // color: "white",
    position: "relative",
  },
  cardBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundSize: "cover",
    opacity: 0.5,
  },
  cardText: {
    zIndex: 1,
    display: "flex",
    marginBottom: -8,
    padding: 0,
  },
  cardTextPoints: {
    zIndex: 1,
    background: "rgba(0, 0, 0, 0.6)",
    paddingTop: 5,
    flex: 1,
    textAlign: "center",
    color: "white",
  },
};


const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default class RSLeftMenu extends React.PureComponent {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onMenuItemSelected: PropTypes.func.isRequired,
    onVisibleChange: PropTypes.func,
    user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    categories: PropTypes.array,
    profiles: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.toggleAccountExpanded = this.toggleAccountExpanded.bind(this);

    this.state = {
      accountExpanded: false,
      expanded: false,
    };
  }

  toggleAccountExpanded() {
    const { accountExpanded } = this.state;
    this.setState({
      accountExpanded: !accountExpanded,
    });
  }

  // /////////////////
  // render

  render() {
    const { visible, onVisibleChange } = this.props;
    return (
      <Drawer docked={false} open={visible} onRequestChange={onVisibleChange}>
        {this.renderMenuItemUser()}
        {this.renderItems()}
      </Drawer>
    );
  }

  renderMenuItemUser() {
    const { user, categories, onMenuItemSelected } = this.props;
    const anonymous = getUserType() === "notAnonymous";
    const username = anonymous
      ? `${user.firstName} ${user.lastName}`
      : user.screenname;
    if (user) {
      return (
        <Card
          style={styles.card}
          expanded={this.state.accountExpanded}
          onClick={() => {
            this.setState({ accountExpanded: !this.state.accountExpanded });
          }}
        >
          <CardActions>
            <div style={styles.cardBackground} />
            <CardHeader
              style={{ marginLeft: 0, paddingLeft: 10 }}
              title={username}
              subheader={
                <div
                  id="userEmail"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "80%",
                  }}
                >
                  {user.email}
                </div>
              }
              avatar={
                !user.imageUrl ? (
                  DefaultAvatar
                ) : (
                  <Avatar
                    src={user.imageUrl}
                    style={{ border: "1px solid #000" }}
                  />
                )
              }
            />
            <ExpandMore
              expand={this.state.accountExpanded}
              aria-expanded={this.state.accountExpanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </ExpandMore>
          </CardActions>
          <Collapse
            in={this.state.accountExpanded}
            unmountOnExit
          >
            <CardContent style={styles.cardText} expandable>
              {map(categories, (category) => {
                const points = get(
                  find(user.points, { rewardCategoryId: category.id }),
                  "points"
                );
                return (
                  <div style={styles.cardTextPoints} key={category.id}>
                    <FormattedMessage {...messages.myPoints} />
                    <h3 style={{ margin: "5px 0" }}>
                      <FormattedNumber value={points} />
                    </h3>
                  </div>
                );
              })}
            </CardContent>
          </Collapse>
        </Card>
      );
    }
  }

  renderItems() {
    const { user } = this.props;
    const { accountExpanded } = this.state;
    if (user && accountExpanded) {
      return this.renderAccountExpanded();
    }
    return this.renderAccountCollapsed();
  }
  checkCaregiverFlow(onMenuItemSelected) {
    const {
      user: { isPpAccepted, isTosAccepted },
    } = this.props;
    if (Number(isTosAccepted) === 0) {
      return onMenuItemSelected("/pages/tos");
    }
    if (Number(isPpAccepted) === 0) {
      return onMenuItemSelected("/pages/privacy");
    }
    return onMenuItemSelected("/register-girls");
  }

  renderAccountExpanded() {
    const {
      onMenuItemSelected,
      user: { userGroup },
    } = this.props;

    return (
      <div>
        {/*userGroup === 'caregiver' && <MenuItem
          primaryText={<FormattedMessage {...messages.menuItemRegisterGirls} />}
          leftIcon={<Icon className="material-icons">mail_outline</Icon>}
          onClick={() => this.checkCaregiverFlow(onMenuItemSelected)}
    />*/}
        <MenuItem onClick={() => onMenuItemSelected("/redemptions")}>
          <Redeem style={{ color: "grey", marginRight: "10px" }} />
          <FormattedMessage {...messages.menuItemRedemptions} />
        </MenuItem>
        <MenuItem onClick={() => onMenuItemSelected("/points")}>
          <History style={{ color: "grey", marginRight: "10px" }} />
          <FormattedMessage {...messages.menuItemPoints} />
        </MenuItem>
        <MenuItem onClick={() => onMenuItemSelected("/favorites")}>
          <FavoriteBorder style={{ color: "grey", marginRight: "10px" }} />
          <FormattedMessage {...messages.menuItemFavorites} />
        </MenuItem>
        <MenuItem onClick={() => onMenuItemSelected("/lotteries")}>
          <LocalActivity style={{ color: "grey", marginRight: "10px" }} />
          <FormattedMessage {...messages.menuItemLotteries} />
        </MenuItem>
      </div>
    );
  }

  renderAccountCollapsed() {
    const { /* categories, */ profiles } = this.props;
    return (
      <div>
        {this.renderMenuItemHome()}
        {/*
        <ListSubheader>
          <FormattedMessage {...messages.categories} />
        </ListSubheader>
        {map(categories, (category) => this.renderMenuItemCategory(category))}
        <Divider />
        */}
        {this.renderFooter()}
      </div>
    );
  }

  renderMenuItemHome() {
    const { onMenuItemSelected } = this.props;
    return (
      <MenuItem onClick={() => onMenuItemSelected("/home/all")}>
        <Home style={{ color: "grey", marginRight: "10px" }} />
        <FormattedMessage {...messages.menuItemHome} />
      </MenuItem>
    );
  }

  renderMenuItemCategory(category) {
    const { onMenuItemSelected } = this.props;
    return (
      <MenuItem
        key={category.id}
        onClick={() => onMenuItemSelected(`/home/${category.id}`)}
      >
        {category.name}
      </MenuItem>
    );
  }

  renderMenuItemProfile(profile) {
    const { onMenuItemSelected } = this.props;
    return (
      <MenuItem
        key={profile.id}
        onClick={() => onMenuItemSelected(`/profiles/${profile.id}`)}
      >
        {profile.name}
      </MenuItem>
    );
  }

  renderFooter() {
    const { onMenuItemSelected, profiles } = this.props;
    let helpEmail = "mailto:EYsupport@tribalplanet.com";
    if (profiles.find((item) => item.name && item.name.includes("Aspen"))) {
      helpEmail = "mailto:AIYAF@tribalplanet.com";
    }
    return (
      <div>
        <MenuItem onClick={() => onMenuItemSelected("/rsprivacy")}>
          <Done style={{ color: "grey", marginRight: "10px" }} />
          <FormattedMessage {...messages.menuItemPrivacy} />
        </MenuItem>
        <MenuItem onClick={() => onMenuItemSelected("/rstos")}>
          <DoneAll style={{ color: "grey", marginRight: "10px" }} />
          <FormattedMessage {...messages.menuItemTerms} />
        </MenuItem>
        <MenuItem onClick={() => onMenuItemSelected("/rsfaq")}>
          <HelpOutline style={{ color: "grey", marginRight: "10px" }} />
          <FormattedMessage {...messages.menuItemHelp} />
        </MenuItem>
      </div>
    );
  }
}
